import { Button, Col, Divider, Input, Row, Segmented, Select, Space, Typography } from "antd"
import React, { useEffect, useState } from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { ImInsertTemplate } from "react-icons/im"
import { collection, onSnapshot } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { CloseCircleOutlined } from "@ant-design/icons"
import AllVivaPlates from "./AllVivaPlates"
import VivaPlatesOrders from "./VivaPlatesOrders"

const { Text } = Typography

export default function VivaPlateList() {
  const [loading, setLoading] = useState(false)
  const [platesList, setPlatesList] = useState([])
  const [filteredPlatesList, setFilteredPlatesList] = useState([])
  const [searchText, setSearchText] = useState("")
  const [selectedClient, setSelectedClient] = useState(null)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [uniqueClients, setUniqueClients] = useState([])
  const [uniqueProducts, setUniqueProducts] = useState([])
  const [selectedView, setSelectedView] = useState("Printing")

  // Gets data
  useEffect(() => {
    setLoading(true)
    const plateRef = collection(db, "vivaPlateList")
    const unsubscribe = onSnapshot(plateRef, (snapshot) => {
      const results = snapshot.docs.map((doc) => {
        const data = doc.data()
        return {
          ...data,
          id: doc.id,
        }
      })
      setPlatesList(results)
      setFilteredPlatesList(results)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  // Extract unique client and product names
  useEffect(() => {
    const clients = [...new Set(platesList.map((plate) => plate.client))]
    setUniqueClients(clients)

    const products = [...new Set(platesList.map((plate) => plate.product))]
    setUniqueProducts(products)
  }, [platesList])

  // Handle search text change
  const handleSearch = (text) => {
    setSearchText(text)
    filterPlates(text, selectedClient, selectedProduct)
  }

  // Handle client selection change
  const handleClientSelect = (client) => {
    setSelectedClient(client)
    filterPlates(searchText, client, selectedProduct)
  }

  // Handle product selection change
  const handleProductSelect = (product) => {
    setSelectedProduct(product)
    filterPlates(searchText, selectedClient, product)
  }

  // Function to filter plates based on search text, selected client, and selected product
  const filterPlates = (searchText, client, product) => {
    let filtered = platesList.filter((plate) =>
      plate.code.toLowerCase().includes(searchText.toLowerCase())
    )

    if (client) {
      filtered = filtered.filter((plate) => plate.client === client)
    }

    if (product) {
      filtered = filtered.filter((plate) => plate.product === product)
    }

    setFilteredPlatesList(filtered)
  }

  // Function to reset search text and filtered plates list
  const handleSearchReset = () => {
    setSearchText("")
    filterPlates("", selectedClient, selectedProduct)
  }

  // Function to reset client selection and filtered plates list
  const handleClientReset = () => {
    setSelectedClient(null)
    filterPlates(searchText, null, selectedProduct)
  }

  // Function to reset product selection and filtered plates list
  const handleProductReset = () => {
    setSelectedProduct(null)
    filterPlates(searchText, selectedClient, null)
  }

  //return proper layout
  const returnView = () => {
    if (selectedView === "Printing") {
      return <VivaPlatesOrders />
    } else {
      return <AllVivaPlates loading={loading} filteredPlatesList={filteredPlatesList} />
    }
  }

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <PageHeader icon={<ImInsertTemplate />} text="Viva plates list" />
        </Col>
        <Col span={24}>
          <Segmented
            options={["Printing", "All Plates"]}
            onChange={(value) => {
              setSelectedView(value) // string
            }}
          />
        </Col>

        <Col span={24}>
          <div className="elevated-white-bg">{returnView()}</div>
        </Col>
      </Row>
    </div>
  )
}
